'use strict';

var PricingSummaryFareChangeByPOSFilterFactory = function PricingSummaryFareChangeByPOSFilterFactory(DataFilter) {
  function PricingSummaryFareChangeByPOS() {
    DataFilter.call(this, 'pricing-summary-fare-change', 'summary-pos', 1);
  }
  PricingSummaryFareChangeByPOS.prototype = Object.create(DataFilter.prototype);
  PricingSummaryFareChangeByPOS.prototype.filter = function (data, range) {
    return DataFilter.prototype.filter(data, range, 'pos');
  };
  return PricingSummaryFareChangeByPOS;
};
PricingSummaryFareChangeByPOSFilterFactory.$inject = ['DataFilterFactory'];
module.exports = PricingSummaryFareChangeByPOSFilterFactory;